import { z } from 'zod';

export const useAccountInformationForm = () => {
	const schema = z.object({
		id: z.number().positive(),
		email: z.string().email(),
		emailConfirmed: z.boolean(),
		phoneNumber: z.string().min(1),
		firstName: z.string().min(1),
		lastName: z.string().min(1),
		city: z.string().min(1),
		zipCode: z.string().min(1),
		country: z.string().min(1),
		bankAccountNumber: z.string().min(1),
		addressLine: z.string().min(1),
		imageUrl: z.string().min(0),
		placementPartnerId: z.number().min(0),
		mentorId: z.number().min(0),
	});

	return {
		schema,
	};
};
